import { APP_VERSION } from "../appVersion";
import { ensureClientFingerprint, getClientLoginHint } from "./clientIdentity";
import { isStandaloneMode } from "./pwaInstallPrompt";

/** Заголовки для учёта контекста клиента и диагностики авторизации. */
export function getClientTraceHeaders(): Record<string, string> {
  const h: Record<string, string> = {
    "X-App-Version": APP_VERSION,
    "X-Client-Fingerprint": ensureClientFingerprint(),
  };

  const loginHint = getClientLoginHint();
  if (loginHint) h["X-Client-Login"] = loginHint;

  if (isStandaloneMode()) {
    h["X-WW-PWA-Standalone"] = "1";
  }

  return h;
}
